import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setload_Screen, Show_MsgBox } from "./features/Message";
import adminApp from "./Utility";

function HideSettings({ onClose }) {
  const dispatch  = useDispatch();
  const _common   = useSelector((store) => store.Common);

  const [activeTab,      setActiveTab]      = useState("screens");
  const [arrClients,     setArrClients]     = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [arrReports,     setArrReports]     = useState([]);
  const [arrScreens,     setArrScreens]     = useState([]);

  useEffect(() => { Load_Clients(); }, []);

  const AlertMessage = (Message, Icon) =>
    dispatch(Show_MsgBox({ Message, Type: Icon, isMsg: true }));

  // ── Load client list ───────────────────────────────────────────────────
  const Load_Clients = async () => {
    try {
      await dispatch(setload_Screen(true));
      await adminApp.get("ClientMaster/Load_HideClients").then((res) => {
        if (res.data.strStatus === "Success") setArrClients(res.data.Clients);
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  // ── Client dropdown change ─────────────────────────────────────────────
  const Handle_ClientChange = async (e) => {
    const selected = arrClients.find((c) => String(c.clientId) === e.target.value);
    setSelectedClient(selected || "");
    setArrReports([]);
    setArrScreens([]);
    if (!selected) return;
    if (activeTab === "reports") await Load_Reports(selected.strMasterDB);
    else await Load_Screens(selected.strMasterDB);
  };

  // ── Tab switch ─────────────────────────────────────────────────────────
  const Handle_TabChange = async (tab) => {
    setActiveTab(tab);
    if (!selectedClient) return;
    if (tab === "reports" && arrReports.length === 0) await Load_Reports(selectedClient.strMasterDB);
    if (tab === "screens" && arrScreens.length === 0) await Load_Screens(selectedClient.strMasterDB);
  };

  // ── Load Reports ───────────────────────────────────────────────────────
  const Load_Reports = async (strMasterDB) => {
    try {
      await dispatch(setload_Screen(true));
      await adminApp.get(`ClientMaster/Load_ReportPermissions/${strMasterDB}`).then((res) => {
        if (res.data.strStatus === "Success") setArrReports(res.data.Reports);
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  // ── Load Screens ───────────────────────────────────────────────────────
  const Load_Screens = async (strMasterDB) => {
    try {
      await dispatch(setload_Screen(true));
      await adminApp.get(`ClientMaster/Load_ScreenPermissions/${strMasterDB}`).then((res) => {
        if (res.data.strStatus === "Success") setArrScreens(res.data.Screens);
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  // ── Toggles ────────────────────────────────────────────────────────────
  const Toggle_Report  = (id) =>
    setArrReports((p) => p.map((r) => r.rptPerId === id ? { ...r, showReport: r.showReport === 1 ? 0 : 1 } : r));

  const Toggle_Screen  = (id) =>
    setArrScreens((p) => p.map((s) => s.scrPerId === id ? { ...s, showScreen: s.showScreen === 1 ? 0 : 1 } : s));

  const ToggleAll_Reports = (hide) =>
    setArrReports((p) => p.map((r) => ({ ...r, showReport: hide ? 0 : 1 })));

  const ToggleAll_Screens = (hide) =>
    setArrScreens((p) => p.map((s) => ({ ...s, showScreen: hide ? 0 : 1 })));

  // ── Save Reports ───────────────────────────────────────────────────────
  const Save_ReportPermissions = async () => {
    if (!selectedClient) { AlertMessage("Please select a client", "error"); return; }
    try {
      await dispatch(setload_Screen(true));
      await adminApp.post("ClientMaster/Update_ReportPermissions", {
        strMasterDB: selectedClient.strMasterDB,
        Reports: arrReports,
      }).then((res) => {
        if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  // ── Save Screens ───────────────────────────────────────────────────────
  const Save_ScreenPermissions = async () => {
    if (!selectedClient) { AlertMessage("Please select a client", "error"); return; }
    try {
      await dispatch(setload_Screen(true));
      await adminApp.post("ClientMaster/Update_ScreenPermissions", {
        strMasterDB: selectedClient.strMasterDB,
        Screens: arrScreens.map((s) => ({
          ScrPerId: s.scrPerId,
          ScrId:    s.scrId,
          ScrName:  s.scrName,
          ShowScreen: s.showScreen,
        })),
      }).then((res) => {
        if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  const hiddenReportCount = arrReports.filter((r) => r.showReport === 0).length;
  const hiddenScreenCount = arrScreens.filter((s) => Number(s.showScreen) === 0).length;

  const activeList   = activeTab === "reports" ? arrReports : arrScreens;
  const hiddenCount  = activeTab === "reports" ? hiddenReportCount : hiddenScreenCount;

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div className="hs-wrap">

      {/* ── Top toolbar ── */}
      <div className="hs-toolbar">

        {/* Client selector */}
        <div className="hs-client-box">
          <label>Client</label>
          <select value={selectedClient?.clientId || ""} onChange={Handle_ClientChange}>
            <option value="">-- Select Client --</option>
            {arrClients.map((c) => (
              <option key={c.clientId} value={c.clientId}>
                {c.clientName}&nbsp;&nbsp;(ID: {c.clientId})
              </option>
            ))}
          </select>
        </div>

        {/* Tabs */}
        <div className="hs-tabs">
          <button
            className={`hs-tab ${activeTab === "screens" ? "active" : ""}`}
            onClick={() => Handle_TabChange("screens")}
          >
            <i className="bx bx-layout"></i> Screens
            {hiddenScreenCount > 0 && <span className="hs-badge">{hiddenScreenCount}</span>}
          </button>
          <button
            className={`hs-tab ${activeTab === "reports" ? "active" : ""}`}
            onClick={() => Handle_TabChange("reports")}
          >
            <i className="fa-solid fa-scroll"></i> Reports
            {hiddenReportCount > 0 && <span className="hs-badge">{hiddenReportCount}</span>}
          </button>
        </div>

        {/* Bulk actions + Save */}
        <div className="hs-actions">
          {activeList.length > 0 && (
            <>
              <span className="hs-count">{hiddenCount} hidden / {activeList.length} total</span>
              <button className="hs-btn-outline"
                onClick={() => activeTab === "reports" ? ToggleAll_Reports(false) : ToggleAll_Screens(false)}>
                <i className="bx bx-show"></i> Show All
              </button>
              <button className="hs-btn-outline red"
                onClick={() => activeTab === "reports" ? ToggleAll_Reports(true) : ToggleAll_Screens(true)}>
                <i className="bx bx-hide"></i> Hide All
              </button>
              <button className="hs-btn-save"
                onClick={() => dispatch(Show_MsgBox({
                  Button: activeTab === "reports" ? Save_ReportPermissions : Save_ScreenPermissions,
                  Question: `Save ${activeTab} visibility changes for this client?`,
                  isdialog: true,
                }))}>
                <i className="bx bx-save"></i> Save
              </button>
            </>
          )}
        </div>
      </div>

      {/* ── Table header ── */}
      <div className="hs-table-head">
        <span className="hs-col-sno">#</span>
        <span className="hs-col-name">{activeTab === "reports" ? "Report Name" : "Screen Name"}</span>
        <span className="hs-col-status">Status</span>
        <span className="hs-col-toggle">Hide</span>
      </div>

      {/* ── Table body ── */}
      <div className="hs-table-body">

        {/* Empty: no client selected */}
        {!selectedClient && (
          <div className="hs-empty">
            <i className="bx bx-user-circle"></i>
            <p>Select a client to load {activeTab}</p>
          </div>
        )}

        {/* Empty: client selected but no data */}
        {selectedClient && activeList.length === 0 && (
          <div className="hs-empty">
            <i className={activeTab === "reports" ? "fa-solid fa-scroll" : "bx bx-layout"}></i>
            <p>No {activeTab} found for this client</p>
          </div>
        )}

        {/* Reports rows */}
        {activeTab === "reports" && arrReports.map((rpt, idx) => (
          <div key={rpt.rptPerId} className={`hs-row ${rpt.showReport === 0 ? "is-hidden" : ""}`}>
            <span className="hs-col-sno">{idx + 1}</span>
            <span className="hs-col-name">{rpt.rptName}</span>
            <span className="hs-col-status">
              {rpt.showReport === 0
                ? <span className="hs-pill red">Hidden</span>
                : <span className="hs-pill green">Visible</span>}
            </span>
            <span className="hs-col-toggle">
              <label className="hs-switch">
                <input type="checkbox" checked={rpt.showReport === 0}
                  onChange={() => Toggle_Report(rpt.rptPerId)} />
                <span className="hs-knob"></span>
              </label>
            </span>
          </div>
        ))}

        {/* Screens rows */}
        {activeTab === "screens" && arrScreens.map((scr, idx) => (
          <div key={scr.scrPerId} className={`hs-row ${Number(scr.showScreen) === 0 ? "is-hidden" : ""}`}>
            <span className="hs-col-sno">{idx + 1}</span>
            <span className="hs-col-name">{scr.scrName}</span>
            <span className="hs-col-status">
              {Number(scr.showScreen) === 0
                ? <span className="hs-pill red">Hidden</span>
                : <span className="hs-pill green">Visible</span>}
            </span>
            <span className="hs-col-toggle">
              <label className="hs-switch">
                <input type="checkbox" checked={Number(scr.showScreen) === 0}
                  onChange={() => Toggle_Screen(scr.scrPerId)} />
                <span className="hs-knob"></span>
              </label>
            </span>
          </div>
        ))}
      </div>

      {/* ── CSS ── */}
      <style>{`
        /* Full height inside <main> */
        .hs-wrap {
          display: flex;
          flex-direction: column;
          height: 100%;
          background: #fff;
          overflow: hidden;
        }

        /* ── Toolbar ── */
        .hs-toolbar {
          display: flex;
          align-items: center;
          gap: 0;
          border-bottom: 2px solid #e5e7eb;
          background: #fff;
          flex-shrink: 0;
          flex-wrap: wrap;
        }

        /* Client box */
        .hs-client-box {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 14px;
          border-right: 1px solid #e5e7eb;
          flex-shrink: 0;
        }
        .hs-client-box label {
          font-size: 11px;
          font-weight: 700;
          color: #1b5e20;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          white-space: nowrap;
        }
        .hs-client-box select {
          padding: 5px 10px;
          border: 1px solid #a5d6a7;
          border-radius: 6px;
          font-size: 12px;
          color: #1e293b;
          outline: none;
          background: #fff;
          min-width: 210px;
          cursor: pointer;
        }
        .hs-client-box select:focus { border-color: #1b5e20; }

        /* Tabs */
        .hs-tabs {
          display: flex;
          padding: 0 8px;
          flex-shrink: 0;
          border-right: 1px solid #e5e7eb;
        }
        .hs-tab {
          padding: 10px 16px;
          border: none;
          background: none;
          font-size: 12px;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          border-bottom: 3px solid transparent;
          margin-bottom: -2px;
          display: flex;
          align-items: center;
          gap: 5px;
          transition: color 0.15s, border-color 0.15s;
          white-space: nowrap;
        }
        .hs-tab.active { color: #1b5e20; border-bottom-color: #1b5e20; }
        .hs-tab:hover:not(.active) { color: #2e7d32; }
        .hs-badge {
          background: #fee2e2;
          color: #dc2626;
          font-size: 10px;
          font-weight: 700;
          border-radius: 10px;
          padding: 1px 6px;
        }

        /* Actions */
        .hs-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 0 14px;
          flex: 1;
          justify-content: flex-end;
        }
        .hs-count {
          font-size: 11px;
          color: #64748b;
          margin-right: 4px;
        }
        .hs-btn-outline {
          font-size: 11px;
          font-weight: 600;
          padding: 5px 12px;
          border: 1px solid #a5d6a7;
          border-radius: 5px;
          background: #fff;
          color: #1b5e20;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 4px;
          transition: background 0.12s;
          white-space: nowrap;
        }
        .hs-btn-outline:hover { background: #e8f5e9; }
        .hs-btn-outline.red { color: #dc2626; border-color: #fca5a5; }
        .hs-btn-outline.red:hover { background: #fff5f5; }
        .hs-btn-save {
          font-size: 12px;
          font-weight: 700;
          padding: 6px 18px;
          border: none;
          border-radius: 6px;
          background: #1b5e20;
          color: #fff;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 5px;
          transition: background 0.15s;
          white-space: nowrap;
        }
        .hs-btn-save:hover { background: #145214; }

        /* ── Table header — matches your existing th style ── */
        .hs-table-head {
          display: flex;
          align-items: center;
          background: #1b5e20;
          color: #f7f6fb;
          font-size: 12px;
          font-weight: 500;
          padding: 0 10px;
          height: 30px;
          flex-shrink: 0;
          position: sticky;
          top: 0;
          z-index: 2;
        }

        /* ── Table body ── */
        .hs-table-body {
          flex: 1;
          overflow-y: auto;
        }

        /* Row */
        .hs-row {
          display: flex;
          align-items: center;
          padding: 0 10px;
          height: 28px;
          border-bottom: 1px solid rgb(241, 246, 248);
          font-size: 12px;
          color: #000;
          cursor: pointer;
          transition: background 0.1s;
        }
        .hs-row:hover { background: #f2f2f2; }
        .hs-row.is-hidden { color: #94a3b8; background: #fafafa; }
        .hs-row.is-hidden:hover { background: #fff5f5; }

        /* Columns — matching your table column widths */
        .hs-col-sno    { width: 40px;  flex-shrink: 0; color: #94a3b8; }
        .hs-col-name   { flex: 1; }
        .hs-col-status { width: 80px;  flex-shrink: 0; text-align: center; }
        .hs-col-toggle { width: 60px;  flex-shrink: 0; display: flex; justify-content: center; }

        /* Pills */
        .hs-pill {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          padding: 1px 8px;
          border-radius: 10px;
          white-space: nowrap;
        }
        .hs-pill.red   { background: #fee2e2; color: #dc2626; }
        .hs-pill.green { background: #dcfce7; color: #16a34a; }

        /* Toggle switch */
        .hs-switch {
          position: relative;
          display: inline-block;
          width: 36px;
          height: 18px;
          cursor: pointer;
        }
        .hs-switch input { opacity: 0; width: 0; height: 0; }
        .hs-knob {
          position: absolute;
          inset: 0;
          background: #cbd5e1;
          border-radius: 18px;
          transition: background 0.2s;
        }
        .hs-knob:before {
          content: "";
          position: absolute;
          width: 12px; height: 12px;
          left: 3px; top: 3px;
          background: #fff;
          border-radius: 50%;
          transition: transform 0.2s;
          box-shadow: 0 1px 3px rgba(0,0,0,0.25);
        }
        .hs-switch input:checked + .hs-knob { background: #ef4444; }
        .hs-switch input:checked + .hs-knob:before { transform: translateX(18px); }

        /* Empty state */
        .hs-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          color: #94a3b8;
          font-size: 13px;
          gap: 10px;
        }
        .hs-empty i   { font-size: 40px; color: #cbd5e1; }
        .hs-empty p   { margin: 0; }
      `}</style>
    </div>
  );
}

export default HideSettings;